export default __webpack_public_path__ + "static/media/6.9f62e015.png";